import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/appSettings'

function* fetchAppSettingssRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchAppSettingss'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_APPSETTINGS,
    result,
  })
}

function* fetchAppSettingss({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchAppSettingss'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchAppSettingss', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_APPSETTINGS,
    result,
  })
}

function* fetchAppSettingsEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_APPSETTINGS,
    result,
  })
}

// function* fetchAppSettingsSave(values) {
//   yield put({
//     type: actions.REQUESTING,
//   })
//   const result = yield call(save, values)
//   if (result !== null) {
//     notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
//   }
//   yield put({
//     type: actions.SAVE_APPSETTINGS_RECIEVED,
//     result,
//   })
//   yield put({
//     type: actions.RE_FETCH_APPSETTINGSS,
//   })
// }


function* fetchAppSettingsSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  yield put({
    type: actions.EDIT_APPSETTINGS,
    result,
  });
}




function* fetchAppSettingsDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_APPSETTINGS_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_APPSETTINGSS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_APPSETTINGSS, fetchAppSettingss),
    takeEvery(actions.FETCH_APPSETTINGS, fetchAppSettingsEdit),
    takeEvery(actions.SAVE_APPSETTINGS, fetchAppSettingsSave),
    takeEvery(actions.DELETE_APPSETTINGS, fetchAppSettingsDelete),
    takeEvery(actions.RE_FETCH_APPSETTINGSS, fetchAppSettingssRefresh),
  ])
}
